window.theme = window.theme || {};

window.theme.CartGiftWrap = (function() {
    
    function CartGiftWrap(container){
    this.container = container;

    this.data = {};

    this.giftWrapContainer = this.container;
    this.sideBarContainer = document.querySelector('#sidebar-cart') ? document.querySelector('#sidebar-cart') : null ;

    this.textArea = document.querySelector("#gift-message-input");
    this.characterCounter = this.container.querySelector("#char_count");

    this.giftWrapMessage = this.giftWrapContainer.querySelector('#gift-message-input');
    this.giftWrapCheckbox = this.giftWrapContainer.querySelector('#gift-wrap input[type="checkbox"]');    
    this.giftReceiptCheckbox = this.giftWrapContainer.querySelector('#gift-receipt input[type="checkbox"]');
    
    this.languages = window.cartGiftWrapLanguages;
    
    this.initGiftWrapForm();
  }
  return CartGiftWrap;
})();

window.theme.CartGiftWrap.prototype = {

  initGiftWrapForm: function(){
    var self = this;

    self.updateTextRemaining()

    if (window.location.href.indexOf('/cart') > 0) {
      self.bindEventsCartPage();
    }
    else {
      self.bindEventsCartDrawer();
    }
  },

  bindEventsCartDrawer: function(){
    var self = this;
    
    let buttonOpen = self.sideBarContainer.querySelector('#Cart__GiftWrapButtonOpen');
    buttonOpen.addEventListener('click', function(e){
      self.giftWrapContainer.setAttribute("aria-hidden", "false");
    });

    let buttonSave = self.sideBarContainer.querySelector('#Cart__GiftWrapButtonSave');
    buttonSave.addEventListener('click', function(e){
      // save attributes
      self.saveGiftWrapAttributes();
      // update text
      self.updateCartDrawerButtonOpenText();
      //close drawer
      self.giftWrapContainer.setAttribute("aria-hidden", "true");
    });

    let buttonClear = self.sideBarContainer.querySelector('#Cart__GiftWrapButtonClear');
    buttonClear.addEventListener('click', function(e){
      self.clearGiftWrapAttributes();
      self.updateCartDrawerButtonOpenText();
    });

    // init char count
    this.textArea.addEventListener("input", function() {
      self.updateTextRemaining();
    });
  },

  bindEventsCartPage: function(){
    var self = this;
    
    let buttonSave = self.giftWrapContainer.querySelector('#Cart__GiftWrapButtonSave');
    buttonSave.addEventListener('click', function(e){
      // save attributes
      self.saveGiftWrapAttributes();
      // hide previous result message
      let resultMessageContainer = self.giftWrapContainer.querySelector('#gift-wrap-result');
      resultMessageContainer.classList.add('hidden');

    });

    // init char count
    this.textArea.addEventListener("input", function() {
      self.updateTextRemaining();
    });
  },

  saveGiftWrapAttributes: function(){
    var self = this;
    
    let attributes = self.getGiftWrapAttributes();
    self.updateCartAttributes(attributes);
    
  },

  clearGiftWrapAttributes: function(){
    var self = this;
    
    let attributes = {
      'Gift Message': null,
      'Gift Wrap': null,
      'Gift Receipt': null
    }

    self.clearGiftWrapAttributesElements();
    self.updateCartAttributes(attributes);
  },

  clearGiftWrapAttributesElements: function() {
    var self = this;

    this.giftWrapMessage.value = null;
    this.giftWrapCheckbox.checked = false;
    this.giftReceiptCheckbox.checked = false;

  },

  showCartPageResultMessage: function(resultStatus) {
    var self = this;

    let resultMessageContainer = this.giftWrapContainer.querySelector('#gift-wrap-result');
    let resultMessage = this.giftWrapContainer.querySelector('#gift-wrap-result span');

    if (resultStatus == 200) {
      resultMessageContainer.classList.remove('hidden');
      resultMessage.innerText = this.languages.result_success
    }
    else {
      resultMessageContainer.classList.remove('hidden');
      resultMessage.innerText = this.languages.result_error
    }

  },

  updateCartDrawerButtonOpenText: function(){
    var self = this;

    let attributes = self.getGiftWrapAttributes();

    let attributesAreEmpty = Object.values(attributes).every(x => x === null);
    if (attributesAreEmpty) {
      self.sideBarContainer.querySelector('#Cart__GiftWrapButtonOpen').innerText = this.languages.add;
      self.sideBarContainer.querySelector('#Cart__GiftWrapButtonClear').innerText = '';
    }
    else {
      self.sideBarContainer.querySelector('#Cart__GiftWrapButtonOpen').innerText = this.languages.edit;
      self.sideBarContainer.querySelector('#Cart__GiftWrapButtonClear').innerText = this.languages.clear;
    }
  },

  updateTextRemaining: function(){
    var self = this;

    const maxNumOfChars = 250;

    let numOfEnteredChars = this.textArea.value.length;
    let counter = maxNumOfChars - numOfEnteredChars;
    this.characterCounter.innerText = `Remaining characters: ${counter}`;
  },

  getGiftWrapAttributes: function() {
    var self = this;

    let attributeObject = {};

    attributeObject['Gift Message'] = this.giftWrapMessage.value ? this.giftWrapMessage.value : null;
    attributeObject['Gift Wrap'] = this.giftWrapCheckbox.checked ? 'Yes' : null;
    attributeObject['Gift Receipt'] = this.giftReceiptCheckbox.checked ? 'Yes' : null;

    return attributeObject;
  },

  updateCartAttributes: async function(cartAttributes){
    var self = this;
    console.log(cartAttributes);

    fetch(window.routes.cartUrl + "/update.js", {
      body: JSON.stringify({
        attributes: cartAttributes
      }),
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
    .then(response => {
        console.log(response);

        if (window.location.href.indexOf('/cart') > 0 ) {
          this.showCartPageResultMessage(response.status);
        }
    })
    .catch(error => {
        console.log(error);

        if (window.location.href.indexOf('/cart') > 0 ) {
          this.showCartPageResultMessage(error);
        }
    });
  },

};

document.addEventListener("DOMContentLoaded", function(event) {
  // check that container exists
  const giftWrapContainer = document.querySelector('#gift-wrap-container');
  if (giftWrapContainer){
    // if it exists, call the thing
    window.initCartGiftWrap = new window.theme.CartGiftWrap(giftWrapContainer);
  }
});